import { useEffect } from 'react'
import { Text, Stack, IconErrorOutline } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import HasPaymentMethodCard from '@/components/ds-checkout-modal/has-payment-method-card'
const HasPaymentMethod = ({ showExpiryDateWarning, paymentMethod, setState }: any) => {
  const { t } = useTranslation()
  const paymentMethodState = paymentMethod.state
  useEffect(() => {
    if (paymentMethodState) {
      setState(paymentMethodState)
    }
  }, [paymentMethodState])
  return (
    <Stack space="xsmall">
      <HasPaymentMethodCard paymentMethod={paymentMethod} />
      {showExpiryDateWarning && (
        <Text size="small" icon={<IconErrorOutline tone="critical" />} tone="critical">
          {t(
            'r.payment.edit.payment_method.expired.validation.text',
            'Please update your payment method.'
          )}
        </Text>
      )}
    </Stack>
  )
}

export default HasPaymentMethod
